import { useMemo } from 'react';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';
import { stampsAndEndiciaLabelProviderIds, getIsLabelProviderIdExcludedFromYourCarriersFee } from '../enums/providers';

export const useSellerLabelProviders = (labelProviderId) => {
  const sellerLabelProviders = useSelector(Global.selectSellerLabelProviders);
  return useMemo(() => {
    return sellerLabelProviders.filter((sellerLabelProvider) => {
      return !labelProviderId || sellerLabelProvider.labelProviderId === labelProviderId;
    });
  }, [sellerLabelProviders, labelProviderId]);
};

const selectNonWalletedSellerLabelProviders = createSelector(Global.selectSellerLabelProviders, (slps) => slps.filter((p) => !p.walletId));
export const selectActiveNonWalletedSellerLabelProviders = createSelector(selectNonWalletedSellerLabelProviders, (slps) =>
  slps.filter((p) => p.status === 'Active'),
);

const selectNonWalletedAndNonExcludedSellerLabelProviders = createSelector(Global.selectSellerLabelProviders, (slps) =>
  slps.filter((p) => !p.walletId && !getIsLabelProviderIdExcludedFromYourCarriersFee(p.labelProviderId)),
);
export const useNonWalletedAndNonExcludedSellerLabelProviders = () => {
  const nonWalletedAndNonExcludedSellerLabelProviders = useSelector(selectNonWalletedAndNonExcludedSellerLabelProviders);
  return nonWalletedAndNonExcludedSellerLabelProviders;
};

const selectNonWalletedStampsEndiciaSellerLabelProviders = createSelector(Global.selectSellerLabelProviders, (slps) =>
  slps.filter((p) => !p.walletId && stampsAndEndiciaLabelProviderIds.includes(p.labelProviderId)),
);
export const useHasNonWalletedStampsEndiciaProviders = () => {
  const nonWalletedStampsEndiciaSellerLabelProviders = useSelector(selectNonWalletedStampsEndiciaSellerLabelProviders);
  return !!nonWalletedStampsEndiciaSellerLabelProviders?.length;
};
